import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Landmark,
  GraduationCap,
  Laptop,
  IndianRupee,
  Megaphone,
  FileText,
} from "lucide-react";

import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import HeroHeader from "../component/HeroHeader";

const ServicePage = () => {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      title: "General & Regulatory Services",
      icon: Landmark,
      image: "/img/service1.jpg",
      info: [
        "MSME Acts & Laws, legislation and trade regulations.",
        "Survey reports and gap study for MSME development.",
        "Identification of national & international buyers and sellers.",
        "Research information on trends and product demand.",
        "Identification of financial resources required for projects.",
        "MSME cluster development and support programs.",
      ],
    },
    {
      title: "Skill Development & Capacity Building",
      icon: GraduationCap,
      image: "/img/service2.webp",
      info: [
        "Setting up of Skill Development and Entrepreneurship Development Programme centres.",
        "Product and trade specific skill development programs.",
        "Entrepreneurship development training for unemployed youth.",
        "Training of Trainers in technical skill areas.",
        "End-to-end training covering technology, marketing, export and packaging.",
      ],
    },
    {
      title: "Technology Transfer & Development",
      icon: Laptop,
      image: "/img/service3.webp",
      info: [
        "Technology transfer assistance and installation support.",
        "Information about machinery manufacturers and suppliers.",
        "Technology upgradation for product and process improvement.",
        "Prototype development and R&D support.",
        "Support in setting up Effluent Treatment Plants.",
      ],
    },
    {
      title: "Credit & Financial Services",
      icon: IndianRupee,
      image: "/img/service4.jpg",
      info: [
        "Preparation of Detailed Project Report.",
        "Diagnostic Study Report preparation.",
        "Linking MSMEs with banks and financial institutions.",
        "Assistance in government subsidies and grants.",
        "Financial planning and funding solutions.",
      ],
    },
    {
      title: "Marketing Promotion Services",
      icon: Megaphone,
      image: "/img/service5.jpg",
      info: [
        "Access to global regulations and export opportunities.",
        "Buyer-Seller meets and B2B networking.",
        "Trade fairs and exhibitions for MSMEs.",
        "Tender information from government organizations.",
        "Identifying international distributors.",
      ],
    },
    {
      title: "Research & Policy Advocacy",
      icon: FileText,
      image: "/img/service6.jpg",
      info: [
        "Need assessment survey reports.",
        "Research studies on MSME development issues.",
        "Policy preparation and recommendations.",
        "Advisory on finance, trade and entrepreneurship.",
        "Implementation of MSME schemes and programmes.",
      ],
    },
  ];

  const currentService = services[activeService];

  return (
    <div className="bg-gray-50 min-h-screen text-gray-800">
      <Navbar />

      <div className="flex max-w-7xl mx-auto">

        {/* Sidebar */}
        <aside className="w-72 border-r bg-white min-h-screen px-6 py-10">

          <h2 className="text-lg font-semibold text-gray-900 mb-6">
            Our Services
          </h2>

          <nav className="space-y-2">

            {services.map((service, index) => {
              const Icon = service.icon;

              return (
                <button
                  key={index}
                  onClick={() => setActiveService(index)}
                  className={`w-full flex items-center gap-3 p-4 rounded-lg text-left transition
                  ${
                    activeService === index
                      ? "bg-blue-50 border border-blue-200 text-blue-900"
                      : "hover:bg-gray-100 text-gray-600"
                  }`}
                >

                  <Icon size={20} />

                  <span className="text-sm font-medium">
                    {service.title}
                  </span>
                </button>
              );
            })}

          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-8 lg:p-8">

          {/* Hero Section */}
          <div className="mb-12 rounded-xl overflow-hidden shadow-md border">

            <HeroHeader
              title={currentService.title}
              subtitle="Empowering MSMEs through world-class services and global collaboration."
              backgroundImage={currentService.image}
              height="40vh"
              overlayColor="rgba(0,0,0,0.45)"
            />

          </div>

          <AnimatePresence mode="wait">

            <motion.div
              key={activeService}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -15 }}
              transition={{ duration: 0.3 }}
              className="grid md:grid-cols-2 gap-6"
            >

              {currentService.info.map((point, index) => {
                const Icon = currentService.icon;

                return (
                  <motion.div
                    key={index}
                    whileHover={{ y: -6 }}
                    className="group flex gap-4 bg-white border rounded-xl p-6 shadow-sm hover:shadow-lg transition-all"
                  >

                    <div className="bg-blue-100 text-blue-900 p-3 rounded-lg shrink-0">
                      <Icon size={20} />
                    </div>

                    <p className="text-gray-700 text-[15px] leading-relaxed font-medium group-hover:text-gray-900 transition">
                      {point}
                    </p>

                  </motion.div>
                );
              })}

            </motion.div>

          </AnimatePresence>

        </main>
      </div>

      <Footer />
    </div>
  );
};

export default ServicePage;